if (!customElements.get('cjs-header-search')) {
  customElements.define('cjs-header-search', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.input = this.querySelector('input[name="q"]');
      this.panel = this.querySelector('.cjs-search__dropdown');
      this.status = this.querySelector('[data-cjs-status]');
      this.cache = new Map();
      this.engine = '';
      this.version = 0;
      this.index = -1;
      this.input.addEventListener('input', event => {
        this.cancel();
        this.close();
        if (event.isComposing || !this.input.value.trim()) return;
        this.timer = setTimeout(() => this.search(), 180);
      }, options);
      this.input.addEventListener('compositionend', () => {
        this.cancel();
        if (this.input.value.trim()) this.timer = setTimeout(() => this.search(), 180);
      }, options);
      this.input.addEventListener('focus', () => {
        if (this.input.value.trim()) this.search();
      }, options);
      this.input.addEventListener('keydown', event => this.keydown(event), options);
      this.panel.addEventListener('click', event => {
        const engineLink = event.target.closest('[data-cjs-engine]');
        if (!engineLink) return;
        event.preventDefault();
        this.engine = engineLink.dataset.cjsEngine;
        let engineInput = this.querySelector('input[name="filter.p.m.custom.engine"]');
        if (!engineInput) {
          engineInput = document.createElement('input');
          engineInput.type = 'hidden';
          engineInput.name = 'filter.p.m.custom.engine';
          this.querySelector('form').append(engineInput);
        }
        engineInput.value = this.engine;
        let genericInput = this.querySelector('[data-cjs-ls-filter]');
        if (!genericInput) {
          genericInput = document.createElement('input');
          genericInput.type = 'hidden'; genericInput.name = engineInput.name;
          genericInput.dataset.cjsLsFilter = ''; genericInput.value = 'LS Series';
          this.querySelector('form').append(genericInput);
        }
        genericInput.disabled = !this.engine;
        engineInput.disabled = !this.engine;
        this.search();
      }, options);
      this.panel.addEventListener('pointerdown', event => event.preventDefault(), options);
      this.panel.addEventListener('pointermove', () => this.select(-1), options);
      this.addEventListener('focusout', () => queueMicrotask(() => {
        if (!this.contains(document.activeElement)) { this.cancel(); this.close(); }
      }), options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) { this.cancel(); this.close(); }
      }, options);
    }
    disconnectedCallback() { this.events?.abort(); this.cancel(); }
    cancel() { clearTimeout(this.timer); this.request?.abort(); this.version++; }
    close() {
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded','false');
      this.input.removeAttribute('aria-activedescendant');
      this.status.textContent = '';
      this.select(-1);
    }
    open() {
      if (!this.contains(document.activeElement)) return;
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded','true');
      this.querySelectorAll('.cjs-menu__disclosure[open]').forEach(item => item.open = false);
      this.closest('cjs-clean-menu')?.querySelectorAll('.cjs-menu__disclosure[open]').forEach(item => item.open = false);
    }
    select(index) {
      this.index = index;
      const items = [...this.panel.querySelectorAll('[data-cjs-option]')];
      items.forEach((item,i) => item.setAttribute('aria-selected',String(i === index)));
      const active = items[index];
      if (active) {
        this.input.setAttribute('aria-activedescendant',active.id);
        active.scrollIntoView({block:'nearest'});
      } else this.input.removeAttribute('aria-activedescendant');
    }
    keydown(event) {
      if (event.key === 'Escape') {
        this.cancel(); this.close(); event.stopPropagation(); event.preventDefault(); return;
      }
      if (this.panel.hidden) return;
      const items = [...this.panel.querySelectorAll('[data-cjs-option]')];
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && items.length) {
        event.preventDefault();
        const next = event.key === 'ArrowDown' ? this.index + 1 : this.index < 0 ? items.length - 1 : this.index - 1;
        this.select((next + items.length) % items.length);
      } else if (event.key === 'Enter' && this.index >= 0) {
        event.preventDefault(); items[this.index]?.querySelector('a').click();
      } else if (event.key === 'Tab') {
        this.panel.querySelector('[data-cjs-all]')?.setAttribute('tabindex','0');
        items.forEach(item => item.querySelector('a').setAttribute('tabindex','0'));
      }
    }
    render(markup) {
      this.panel.innerHTML = markup;
      this.panel.querySelectorAll('[data-cjs-option]').forEach((item,i) => item.id = this.panel.id + '-option-' + i);
      this.select(-1);
      const engineSummary = this.panel.querySelector('.cjs-search__engines summary');
      if (this.engine && engineSummary) engineSummary.firstChild.textContent += ': ' + this.engine + ' + LS Series';
      const allResults = this.panel.querySelector('[data-cjs-all]');
      if (this.engine && allResults) {
        const url = new URL(allResults.href);
        url.searchParams.set('filter.p.m.custom.engine',this.engine);
        url.searchParams.append('filter.p.m.custom.engine','LS Series');
        allResults.href = url.toString();
      }
      this.open();
      this.status.textContent = this.panel.querySelector('[data-cjs-announcement]')?.textContent || '';
    }
    async search() {
      const term = this.input.value.trim();
      if (!term || !this.contains(document.activeElement)) return;
      this.cancel();
      const version = this.version;
      const key = this.engine + ':' + term.toLowerCase();
      if (this.cache.has(key)) { this.render(this.cache.get(key)); return; }
      const request = this.request = new AbortController();
      this.panel.replaceChildren();
      const message = document.createElement('p');
      message.className = 'cjs-search__message';
      message.textContent = this.dataset.loading;
      this.panel.append(message);
      this.open();
      this.status.textContent = this.dataset.loading;
      try {
        const url = new URL(this.engine ? this.querySelector('form').action : this.dataset.url, location.origin);
        if (this.engine) {
          url.searchParams.set('type','product');
          url.searchParams.set('filter.p.m.custom.engine',this.engine);
        url.searchParams.append('filter.p.m.custom.engine','LS Series');
        }
        url.searchParams.set('q',term);
        url.searchParams.set('section_id','cjs-header-predictive');
        url.searchParams.set('resources[type]','product,collection');
        url.searchParams.set('resources[limit]','6');
        url.searchParams.set('resources[limit_scope]','each');
        const response = await fetch(url,{signal:request.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const content = doc.querySelector('[data-cjs-search-content]');
        if (!content) throw new Error('Missing search content');
        if (version !== this.version || request.signal.aborted) return;
        this.cache.set(key,content.outerHTML);
        if (this.cache.size > 30) this.cache.delete(this.cache.keys().next().value);
        this.render(content.outerHTML);
      } catch(error) {
        if (request.signal.aborted || version !== this.version) return;
        this.panel.replaceChildren();
        message.textContent = this.dataset.error;
        this.panel.append(message);
        this.status.textContent = this.dataset.error;
        this.open();
      }
    }
  });
}

// LS Series fitment includes every LS-family engine. Keep Shopify's native
// collection/search facets, including keyboard and mobile submissions, intact.
document.addEventListener('formdata', (event) => {
  if (!(event.target instanceof HTMLFormElement) || !event.target.closest('facets-form-component')) return;
  const key = 'filter.p.m.custom.engine';
  const engines = event.formData.getAll(key);
  if (engines.some((engine) => /^(?:LS(?:[1-9]|A)?|L(?:76|77|98))$/i.test(engine)) && !engines.includes('LS Series')) {
    event.formData.append(key, 'LS Series');
  }
}, true);
